import { Component, Input } from '@angular/core';
import { DatepickerHelperService } from '../helpers/datepicker-helper';
import * as moment from 'moment';


@Component({
    template: `{{_value}}`,
    providers: [DatepickerHelperService]
})
export class CustomDateCellComponent {
    _value: string;

    constructor(private datepickerHelperService: DatepickerHelperService) { }

  @Input() set value(value: Date) {

    if (!value) {
      this._value = '';
      return;
    }

    if (typeof (value) === 'number') {
      this._value = moment(value).format('DD/MM/YYYY');

    } else if (isNaN((new Date(value)).getTime())) {
      this._value = '';

    } else {
      this._value = moment(value).format('DD/MM/YYYY');
    }
  }
}
